export default "__VITE_ASSET__BIl6nFFp__"